import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query searchOffers($searchTerm: String, $limit: Int, $page: Int) {
    searchOffers(searchTerm: $searchTerm, limit: $limit, page: $page) {
      totalDocs
      page
      docs {
        id
        name
        description
        tag
        thumbnailImage {
          id
          url
        }
        brand {
          id
          slug
        }
        slug
      }
    }
  }
`

export interface SearchOffersQueryInput {
  searchTerm: string
  limit: number
  page: number
}

const defaultVariables: SearchOffersQueryInput = {
  searchTerm: '',
  limit: 9,
  page: 1,
}

export interface SearchOffersQueryOutput {
  searchOffers: {
    totalDocs: number
    page: number
    docs: {
      id: string
      name: string
      description: string
      tag: string
      thumbnailImage: {
        url: string
      }
      brand: {
        slug: string
      }
      slug: string
    }[]
  }
}

export const useSearchOffersQuery = (options: QueryHookOptions<SearchOffersQueryOutput, SearchOffersQueryInput>) =>
  usePersistedCacheQuery<SearchOffersQueryOutput, SearchOffersQueryInput>(query, {
    ...options
  })


export const searchOffersQuery = { query, defaultVariables }
